import { ArrowForward } from "@mui/icons-material";
import { Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { BreadcrumbBar } from "../Breadcrumb";


export const Reports = ({ ...props }) => {

    return (
        <div>
            <BreadcrumbBar
                current={"Report"}
                previous={[]}
            />
            <Grid container sx={{ my: 3 }} alignItems="flex-end">


            </Grid>
            <Grid container sx={{ my: 3 }}>
                <Grid item xs={12}>
                    <TableContainer component={Paper} >
                        <Table sx={{ marginBottom: 0 }}>

                            <TableBody>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        <Link to={"/report/storage"}> Storage Requests Report</Link>

                                    </TableCell>
                                    <TableCell align="right"><IconButton
                                        component={Link}
                                        to={"/report/storage"}
                                    >
                                        <ArrowForward />
                                    </IconButton></TableCell>

                                </TableRow>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        <Link to={"/report/dispatch"}> Dispatch Requests Report</Link>

                                    </TableCell>
                                    <TableCell align="right"><IconButton
                                        component={Link}
                                        to={"/report/dispatch"}
                                    >
                                        <ArrowForward />
                                    </IconButton></TableCell>

                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    );
}



